export default "__VITE_ASSET__Hv9NH6Fj__"